import { render } from "./CheckPageChief.vue?vue&type=template&id=3993a47e"
import script from "./CheckPageChief.vue?vue&type=script&lang=js"
export * from "./CheckPageChief.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__